import './savethedate.css'
import dayjs from 'dayjs'
import { ReactComponent as Illus1 } from '../../../../../images/hand.svg'

const Savethedate = ({details}) => {

  return (
   <section className={`save-the-date ${details?.theme || ''}`}  >
    <Illus1 className="save-date-illustration" data-aos="fade-up" data-aos-offset={800}/>
    <h1   data-aos="fade-up" >Our Forever Begins</h1>
    {/* <h3> 30.07.06</h3> */}
    <h3  data-aos="fade-up">  {details?.weddingDate
          ? dayjs(details.weddingDate).format('DD.MM.YY')
          : ''}</h3>
         <span className='opening-message'  data-aos="fade-up" >{details?.blessingMessage}</span> 
   </section>
  )
}

export default Savethedate